import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CarouselSection />
        <CardsSection />
        <FaqSection />
        <FeaturesSection />
        <RankingSection />
        <IndexSection />
        <AppSection />
        <UpdatesSection />
        <MediaSection />
        <AboutSection />
        <CommentsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}